import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If we just recovered from a React error boundary "Try Again" remount,
    // restore the scroll position the user had instead of jumping to the top
    // (a plain remount looks identical to a fresh page load otherwise).
    let recoveryScroll = null;
    try {
      const raw = sessionStorage.getItem('__vw_error_recovery_scroll');
      if (raw !== null) {
        sessionStorage.removeItem('__vw_error_recovery_scroll');
        recoveryScroll = parseInt(raw, 10);
      }
    } catch (e) { /* sessionStorage unavailable — ignore */ }

    if (recoveryScroll !== null && !Number.isNaN(recoveryScroll)) {
      window.scrollTo({ top: recoveryScroll, left: 0, behavior: 'instant' });
      return;
    }

    // If there's a hash, let the page handle hash scrolling
    // Otherwise, scroll to top
    if (!hash) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use 'instant' for immediate scroll on route change
      });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
